import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Visibility from "@material-ui/icons/Visibility";
import { useAttendanceLocalMapStyles } from "./styles";
import { Priority } from "../../../../../../../@types/priority";
import { usePriorityStyles } from "../../../../../styles";

type Props = {
  priority: Priority
};

export default function PriorityIcon({ priority }: Props) {
  const [open, setOpen] = useState(false);
  const { classes } = useAttendanceLocalMapStyles();
  const { classes: defaultClasses } = usePriorityStyles();

  function handleDownloadLogo() {
    const link = document.createElement('a');
    link.href = priority.icone;
    link.download = `icone-${priority.sigla_senha}.png`;
    link.rel = "noopener noreferrer";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <Button
        startIcon={<Visibility fontSize="small" />}
        className={classes.button}
        onClick={() => setOpen(true)}
      >
        Visualizar Ícone
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <Card>
          <CardHeader
            avatar={<Visibility />}
            title={<Typography variant="h5">Ícone</Typography>}
            className={classes.cardHeader}
          />
          <CardContent className={classes.cardContent}>
            <img
              src={priority.icone}
              alt="Ícone da prioridade"
              style={{ maxWidth: 80, maxHeight: 80 }}
            />
          </CardContent>
          <CardActions className={classes.cardActions}>
            <Button
              className={classes.button}
              onClick={() => setOpen(false)}
            >
              Fechar
            </Button>
            <Button
              className={defaultClasses.addButton}
              onClick={handleDownloadLogo}
            >
              Baixar
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </>
  );
}
